export const NEW_CIRCLES = [
  "rareimpactfund",
  "alok",
  "leehutchinson",
  "moseswest",
  "peterbond",
  "shabani",
  "juixxe",
  "lawildfire",
  "abundantvillage",
  "fortyniners",
  "daybreaker",
  "eckharttollefoundation",
  "seashepherd",
  "yellowrooms",
  "cleanocean",
  "trilliontrees",
  "cleanlawithme",
  "dollardonationclub",
] as const;

export type NewCircleSlug = (typeof NEW_CIRCLES)[number];
